export default {
  AUDIO_INTERRUPTION: 'audio_interuption',
  CLOSE_APP: 'close_app',
  EXIT_APP: 'exit_app',
  NEW_STATION_START: 'new_station_start',
  PAUSE: 'pause',
  SCAN: 'scan',
  STOP: 'stop',
} as const;
